/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { projectFirestore } from "../../../firebase/config";
import {
  Table,
  Col,
  Row,
  Container,
  Form,
  Button,
  Modal,
  ModalFooter,
  ModalBody,
  ModalHeader,
} from "react-bootstrap";
import {
  faSearch,
  faBars,
  faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  onSnapshot,
  collection,
  query,
  where,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";

// style
import "./Personal.css";

export default function Personal() {
  const { register } = useAuthContext();
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [empleado, setEmpleado] = useState([]);
  const [modQr, setModQr] = useState(false);
  const [selectedBaja, setSelectedBaja] = useState(null);

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };
  const OpenModal = (e) => {
    setEmpleado(e);
    setShowModal(true);
  };

  const bajaEmpleado = () => {
    deleteDoc(doc(projectFirestore, "personal", selectedBaja.id));
    setModQr(false);
  };

  const GuardarCambios = () => {
    setShowModal(false);
    delete empleado.usuario;
    delete empleado.rfc;
    delete empleado.telefono;
    delete empleado.correo;
    const examcollref = doc(projectFirestore, "personal", empleado.id);
    updateDoc(examcollref, empleado)
      .then((response) => {
        alert("Actualizado con exito");
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const ChangeQr = (e) => {
    var qrText =
      "https://quickchart.io/qr?text=RP-" +
      register.id +
      "-P-" +
      e.target.value;
    setData(qrText);
  };

  const handleChange = (e) => {
    if (e.target.name === "barra" && e.target.checked) {
      setEmpleado({
        ...empleado,
        turnero: false,
        [e.target.name]: e.target.checked,
      });
    } else if (e.target.name === "turnero" && e.target.checked) {
      setEmpleado({
        ...empleado,
        barra: false,
        [e.target.name]: e.target.checked,
      });
    } else if (e.target.type === "checkbox") {
      setEmpleado({
        ...empleado,
        [e.target.name]: e.target.checked,
      });
    } else {
      setEmpleado({
        ...empleado,
        [e.target.name]: e.target.value,
      });
    }
  };

  useEffect(() => {
    var qrText =
      "https://quickchart.io/qr?text=RP-" + register.id + "-P-Mesero";
    setData(qrText);
    const filtros = [
      { campo: "id_puesto", operador: "==", valor: register.id },
    ];
    let q = query(collection(projectFirestore, "personal"));
    filtros.forEach((filtro) => {
      const { campo, operador, valor } = filtro;
      q = query(q, where(campo, operador, valor));
    });
    onSnapshot(q, async (docs) => {
      const documentosColeccion = [];
      docs.docs.forEach(async (docp) => {
        let data = docp.data();
        data.id = docp.id;
        const personal = doc(projectFirestore, "users", data.id_usuario);
        onSnapshot(personal, (docum) => {
          if (docum.exists()) {
            const dataU = docum.data();
            data.usuario = dataU.fullName;
            data.correo = dataU.email;
            data.rfc = dataU.rfc;
            data.telefono = dataU.telefono;
            documentosColeccion.push(data);
            setPersonal(documentosColeccion);
          }
        });
      });
    });
  }, [register]);

  return (
    <div className="container">
      <br />
      <h4 className="">PERSONAL</h4>
      <br />
      <div className="row">
        <div className="col-sm-3">
          <div id="project-qr" className="row">
            <div className="col-sm-12">
              <Form.Group controlId="type">
                Puesto
                <select
                  onChange={(e) => {
                    ChangeQr(e);
                  }}
                >
                  <option value={"Mesero"}>Mesero</option>
                  <option value={"Cajero"}>Cajero</option>
                  <option value={"Cocinero"}>Cocinero</option>
                </select>
              </Form.Group>
            </div>
            <div className="center">
              <>
                <img className="qr-code" src={data}></img>
                <div className="center">QR para registrar empleado</div>
              </>
            </div>
          </div>
        </div>
        <div className="col-sm-9">
          <div className="col-sm-8" style={{ paddingBottom: "20px" }}>
            <div className="input-group">
              <Form.Control
                className="form-control border-end-0 border rounded-pill"
                type="text"
                aria-describedby="search-icon"
                placeholder="Busqueda general"
                value={filterText}
                onChange={handleFilterTextChange}
              />
              <span className="input-group-append">
                <button
                  className="btn btn-outline-secondary bg-white border-start-0 border dbutton rounded-pill ms-n3"
                  type="button"
                >
                  <FontAwesomeIcon icon={faSearch} />
                </button>
              </span>
            </div>
          </div>
          <div className="col-sm-4"></div>
          <Table striped bordered hover border="2" id="ex-tblChecador">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>RFC</th>
                <th>Telefono</th>
                <th>Correo</th>
                <th>Puesto</th>
                <th>Permisos</th>
                <th>Baja</th>
              </tr>
            </thead>
            <tbody>
              {personal.map((item) => (
                <tr key={item.id}>
                  <td>{item.usuario}</td>
                  <td>{item.rfc}</td>
                  <td>{item.telefono}</td>
                  <td>{item.correo}</td>
                  <td>{item.id_tipo_puesto}</td>
                  <td className="Filas">
                    <Button
                      variant="primary"
                      className="dbutton"
                      style={{ minWidth: "50px !important" }}
                      onClick={() => OpenModal(item)}
                    >
                      <FontAwesomeIcon icon={faBars} />
                    </Button>
                  </td>
                  <td className="Filas">
                    <Button
                      className="dbutton"
                      variant="danger"
                      style={{ minWidth: "50px !important" }}
                      onClick={() => {
                        setModQr(true);
                        setSelectedBaja(item);
                      }}
                    >
                      <FontAwesomeIcon icon={faUserTimes} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <Modal
        show={modQr}
        onHide={() => {
          setModQr(false);
        }}
      >
        <ModalHeader>Baja de empleado</ModalHeader>
        <ModalBody>
          <div id="project-qr" className="row">
            <div className="col-sm-12">
              ¿Esta seguro que desea dar de baja a este empleado?
              <br />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="dbutton"
            variant="secondary"
            onClick={() => {
              setModQr(false);
            }}
          >
            Cancelar
          </Button>
          <Button className="dbutton" variant="danger" onClick={bajaEmpleado}>
            Confirmar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        onShow={() => {}}
        style={{ minWidth: "200px !important" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Permisos del usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">CONFIGURACION</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.configuracion}
                      onChange={handleChange}
                      name="configuracion"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">CHECADOR</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.checador}
                      onChange={handleChange}
                      name="checador"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">MENU</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.menu}
                      onChange={handleChange}
                      name="menu"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">INVENTARIO</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.inventario}
                      onChange={handleChange}
                      name="inventario"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">PERSONAL</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.personal}
                      onChange={handleChange}
                      name="personal"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">MESEROS</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.meseros}
                      onChange={handleChange}
                      name="meseros"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">MESAS</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.mesas}
                      onChange={handleChange}
                      name="mesas"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">GALERIA</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.galeria}
                      onChange={handleChange}
                      name="galeria"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">RESEÑAS</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.resenas}
                      onChange={handleChange}
                      name="resenas"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">TURNERO</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.turnero}
                      onChange={handleChange}
                      name="turnero"
                      id="turnero"
                    />
                  </div>
                </Row>
              </Col>
              <Col md={6}>
                <Row style={{ margin: "unset !important" }}>
                  <div className="form-switch">
                    <label className="lblqrdinamico">BARRA/COCINA</label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={empleado.barra}
                      onChange={handleChange}
                      name="barra"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </Row>
              </Col>
              {register.type === "truck" && (
                <>
                  <Col md={6}>
                    <Row style={{ margin: "unset !important" }}>
                      <div className="form-switch">
                        <label className="lblqrdinamico">Generador QR</label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={empleado.generador}
                          onChange={handleChange}
                          name="generador"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row style={{ margin: "unset !important" }}>
                      <div className="form-switch">
                        <label className="lblqrdinamico">Ventas/Ordenes</label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={empleado.ventas}
                          onChange={handleChange}
                          name="ventas"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row style={{ margin: "unset !important" }}>
                      <div className="form-switch">
                        <label className="lblqrdinamico">CALIF. TRUCK</label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={empleado.caltruck}
                          onChange={handleChange}
                          name="caltruck"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row style={{ margin: "unset !important" }}>
                      <div className="form-switch">
                        <label className="lblqrdinamico">CALIF. PEDIDOS</label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={empleado.calpedidos}
                          onChange={handleChange}
                          name="calpedidos"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </Row>
                  </Col>
                </>
              )}
            </Row>
            <br />
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="dbutton"
            variant="secondary"
            onClick={() => setShowModal(false)}
          >
            Cerrar
          </Button>
          <Button
            className="dbutton"
            variant="primary"
            onClick={() => GuardarCambios()}
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
